import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ModulesEffects } from './modules.effect';
import { ModulesFacade } from './modules.facade';
import { ModulesService } from './modules.service';
import { modulesReducers } from './modules.reducer';

@NgModule({
  imports: [StoreModule.forFeature('modules', modulesReducers), EffectsModule.forFeature([ModulesEffects])],
  providers: [ModulesService, ModulesFacade],
})
export class ModulesModule {}
